











































import { Vue, Component, Prop } from 'vue-property-decorator';
import sampleData from '@/userManagement/SampleData';
@Component({
  components: {
  },
})
export default class Friend extends Vue {
  mounted() {
    this.$store.dispatch('bindRequest');
  }
  get requests() {
    return this.$store.state.requests;
  }
  // eslint-disable-next-line
  cancelReq(user: any) {
    this.$store.dispatch('removeFromRequests', {
      collection: 'users',
      doc: user.uid,
      sendRequests: 'sendRequests',
      recivedRequests: 'RecivedRequests',
      payload: this.currentUser.uid,
    });
  }
  getPhotoUrl(uid: any) {
    if (this.$store.state.requestsUsers.find((user: any) => user.uid === uid)) {
      return this.$store.state.requestsUsers.find((user: any) => user.uid === uid).photoURL;
    }
    return 'dp';
  }
  showUserProfile(id: any) {
    this.$router.push(`/userProfile/${id}`);
  }
  sampleData() {
    sampleData(this.$store);
  }
  getuserName(uid: any) {
    if (this.$store.state.requestsUsers.find((user: any) => user.uid === uid)) {
      return this.$store.state.requestsUsers.find((user: any) => user.uid === uid).userName;
    }
    return null;
  }
  get currentUser() {
    return this.$store.state.freshCurrentUser;
  }
}
